export default __webpack_public_path__ + "static/media/8.9003a9e6.png";